import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { kevinStreelman } from "@/lib/celebrity-results/kevin-streelman";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Kevin Streelman Hair Transplant Results | RESTORE® Hair";
const DESC = "See PGA Tour winner Kevin Streelman's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2024-09-kevin-s-hold-club-2.webp";

export const Route = createFileRoute("/results/kevin-streelman")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/kevin-streelman/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/kevin-streelman/" },
    ],
  }),
  component: () => <CelebrityResultPage data={kevinStreelman} />,
});
